// extracted by mini-css-extract-plugin
module.exports = {"footer":"ModalClientFired_footer__1mPJ1"};